import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import SecurityPolicyEdit from './containers/SecurityPolicyEdit';
import SecurityPolicyView from './containers/SecurityPolicyView';
import { SECURITY_POLICY_ROUTE } from '../../constants';

interface Props {
}

const SecurityPolicy: FunctionComponent<Props> = (props: any) => {
  return (
    <Fragment>
      <Route exact path={`${SECURITY_POLICY_ROUTE}`}>
        <SecurityPolicyView />
      </Route>
      <Route exact path={`${SECURITY_POLICY_ROUTE}/edit`}>
        <SecurityPolicyEdit />
      </Route>
    </Fragment>
  );
};

export default SecurityPolicy;
